package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class LoginUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(email: String, pass: String): Result<Unit> {
        if (email.isBlank() || pass.isBlank()) {
            return Result.failure(IllegalArgumentException("Preencha e-mail e senha."))
        }
        return authRepository.login(email.trim(), pass)
    }
}
